export const adminReportTranslationsFr = {
  'admin.report.raw_data.title': 'Données brutes',
  'admin.report.vizualization.title': 'Visualisation',
  'admin.report.path.report_not_found': 'Rapport non trouvé',
  'admin.report.modal.title': 'Rapport',
  'admin.report.status.success': 'Succès',
  'admin.report.status.sent': 'Envoyé',
  'admin.report.status.confirmed': 'Confirmé',
  'admin.report.status.sending': 'Envoi en cours',
  'admin.report.status.failed': 'Echec',
  'admin.report.status.error': 'Erreur',
  'admin.report.status.pending': 'En attente',
  'admin.report.status.processing': 'En cours',
  'admin.report.status.cancelled': 'Annulé',
  'admin.report.status.unknown': 'Inconnu',
  'admin.report.back_to_list': 'Retour à la liste',
  'admin.report.title': 'Rapport',
  'admin.report.notifications.status': 'Statut',
  'admin.report.notifications.notification_channel': 'Canal de notification',
  'admin.report.notifications.created_at': 'Date de création',
  'admin.report.notifications.updated_at': 'Date de mise à jour',
  'admin.report.notifications.sended_at': 'Date d’envoi',
  'admin.report.notifications.title': 'Notifications',
  'admin.report.notifications.user': 'Utilisateur',
  'admin.report.notifications.recipient': 'Destinataire',
  'admin.report.producer.table.title': 'Rapport par exploitation',
  'admin.report.producer.producer_ref_column.title': 'Exploitation',
  'admin.report.producer.organization_ref_column.title': 'Organisation',
  'admin.report.producer.report_job_number_column.title': 'Nb rapports',
  'report.query-selector.end-date': 'Date de fin',
  'report.query-selector.start-date': 'Date de début',
  'admin.report.resume.generate.button.label': 'Générer',
  'admin.report.resume.navigation.order.button.label': 'Demandes',
  'admin.report.resume.navigation.exploitations.button.label': 'Exploitations',
  'admin.report.resume.download.button.label': 'Télécharger',
  'admin.report.resume.order.created_at-columns.title': 'Créé le',
  'admin.report.resume.order.ended_at-columns.title': 'Terminé le',
  'admin.report.resume.order.success-columns.title': 'Nb succès',
  'admin.report.resume.order.error-columns.title': 'Nb erreurs',
  'admin.report.resume.order.processing-columns.title': 'En cours',
  'admin.report.resume.order.pending-columns.title': 'En attente',
  'admin.report.resume.order.refresh.button.label': 'Rafraîchir',
  'admin.report.producer.select-all.label': 'Tout sélectionner',
};
